/* global Shopify */
"use strict";

/**
 * If video has no controls and has autoplay enabled,
 * clicking on it should toggle play/pause.
 */
document.addEventListener("click", function (event) {
  var $video = event.target.closest("video");
  if (
    $video &&
    $video.hasAttribute("autoplay") &&
    !$video.hasAttribute("controls")
  ) {
    if ($video.paused) {
      $video.play();
    } else {
      $video.pause();
    }
  }
});

function ajaxform(customer_login_form, recover_password) {
  var post_url = $(customer_login_form).attr("action"),
    //get form action url
    request_method = $(customer_login_form).attr("method"),
    //get form GET/POST method
    parentclass = $(customer_login_form).parent();
  parentclass.find(".error-check").hide();
  var currentLocale = "";

  if (document.documentElement.lang != "en") {
    currentLocale = "/" + document.documentElement.lang;
  }

  var thisdata = {
    "customer[email]": $(customer_login_form)
      .find('input[name="customer[email]"]')
      .val(),
    "customer[password]": $(customer_login_form)
      .find('input[name="customer[password]"]')
      .val(),
    form_type: "customer_login",
    utf8: "✓",
  };
  $.ajax({
    url: post_url,
    type: request_method,
    data: thisdata,
    success: function success(response) {
      var parser = new DOMParser(),
        wrapper = parser.parseFromString(response, "text/html"),
        errors = wrapper.querySelector(".errors"),
        formError = parentclass.data("customError"),
        checkoutURL = parentclass.data("checkoutUrl");

      if (errors != null) {
        parentclass.find(".error-check").html(formError).fadeIn();
      } else {
        window.location.href = checkoutURL;
      }
    },
    error: function error(xhr, ajaxOptions, thrownError) {
      parentclass
        .find(".error-check")
        .html("<p>" + recover_password.attr("data-recover-error") + "</p>")
        .fadeIn();
    },
  });
}

function ajaxformRecover(recoverpasswordform) {
  var post_url = $(recoverpasswordform).attr("action"); //get form action url

  var request_method = $(recoverpasswordform).attr("method"); //get form GET/POST method

  var parentclass = $(recoverpasswordform).parent();
  parentclass.find(".recover_errors").hide();
  var thisdata = {
    email: $(recoverpasswordform).find("#RecoverEmail").val(),
    form_type: "recover_customer_password",
    utf8: "✓",
  };
  $.ajax({
    url: post_url,
    type: request_method,
    data: thisdata,
    success: function success(response) {
      var parser = new DOMParser(),
        wrapper = parser.parseFromString(response, "text/html"),
        errors = wrapper.querySelector(".recover-password--form .errors li"),
        customSuccess = parentclass.attr("data-recover-success");

      if (errors != null) {
        parentclass.find(".recover_errors").html(errors.innerHTML).fadeIn();
      } else {
        parentclass
          .find(".recover_errors")
          .html("<p>" + customSuccess + "</p>")
          .fadeIn();
      }
    },
    error: function error(xhr, ajaxOptions, thrownError) {
      parentclass
        .find(".recover_errors")
        .html("<p>" + parentclass.attr("data-recover-error") + "</p>")
        .fadeIn();
    },
  });
}

function termsandconditionsRegister() {
  $("#agree").change(function () {
    if ($(this).is(":checked")) {
      $("#submit").removeAttr("disabled");
    } else {
      $("#submit").attr("disabled", "disabled");
    }
  });
}

$(window).on("load", function () {
  termsandconditionsRegister();
}); //modal js

var customer_login_form = document.querySelector(
  ".customer_login--form #customer_login"
);

if (customer_login_form) {
  customer_login_form.addEventListener("submit", function (evt) {
    evt.preventDefault();
    var recover_password = $("#recover-password--form");
    ajaxform(customer_login_form, recover_password);
  });
}

var recoverpasswordform = document.querySelector(
  "#recover-password--form form"
);

if (recoverpasswordform) {
  recoverpasswordform.addEventListener("submit", function (evt) {
    evt.preventDefault();
    ajaxformRecover(recoverpasswordform);
  });
} //page js

var customer_login_form_page = document.querySelector(
  ".customer_login--form--page #customer_login"
);

if (customer_login_form_page) {
  customer_login_form_page.addEventListener("submit", function (evt) {
    evt.preventDefault();
    var recover_password = $("#recover-password--form--page");
    ajaxform(customer_login_form_page, recover_password);
  });
}

var recoverpasswordform_page = document.querySelector(
  "#recover-password--form--page form"
);

if (recoverpasswordform_page) {
  recoverpasswordform_page.addEventListener("submit", function (evt) {
    evt.preventDefault();
    ajaxformRecover(recoverpasswordform_page);
  });
}
("use strict");

/*---------------------------------------------------------
    The Header colour transitions
  -----------------------------------------------------------*/
//Waypoint used instead of scrollmagic

if (
  document.querySelector(".full-width") !== null &&
  document.querySelector(".site-nav").classList.contains("colour-change") &&
  document.querySelector(".waypoint-trigger") !== null
) {
  var waypoint = new Waypoint({
    element: document.querySelector(".waypoint-trigger"),
    handler: function handler(direction) {
      if (direction == "down") {
        document.querySelector(".site-nav").classList.remove("colour-change");
        document
          .querySelector(".colour-change-mobile")
          .classList.remove("colour-change");
      }

      if (direction == "up") {
        document.querySelector(".site-nav").classList.add("colour-change");
        document
          .querySelector(".colour-change-mobile")
          .classList.add("colour-change");
      }
    },
  });
}

/*---------------------------------------------------------
        Move Main Menu when footer in viewport
      -----------------------------------------------------------*/

$(window).on("scroll", function () {
  var scrollTop = $(window).scrollTop(),
    elementOffset = $("#shopify-section-footer").offset().top,
    distance = elementOffset - scrollTop,
    menuheight = $(".site-menu").outerHeight(),
    headerheight = menuheight + 80,
    viewportheight = $(window).height(),
    distanceandheader = distance + headerheight,
    finddifference = distance - headerheight;

  if (finddifference <= 0) {
    if (!$(".device-menu").is(":visible")) {
      $(".site-menu").animate(
        {
          marginTop: finddifference,
        },
        1
      );
    }
  } else {
    $(".site-menu").animate(
      {
        marginTop: 0,
      },
      1
    );
  }
});
/*---------------------------------------------------------
      Search reveal
    -----------------------------------------------------------*/
// TODO: Update variables titles, convert to const, use data attr for selection

var search_header = document.getElementById("search-header"),
  search_header_mobile = document.getElementById("search-header--mobile"),
  search_drawer = document.getElementById("search-drawer"),
  search_drawer_close = document.querySelector(".search-drawer__close"),
  main_content = document.querySelector(".main-content"),
  search_input = document.querySelector("#Search-In-Modal-1");

search_header.addEventListener("click", function (e) {
  e.preventDefault();
  document.body.classList.add("no-scroll");
  search_drawer.classList.add("reveal");
  main_content.classList.add("shadow");
  search_input.focus();
  search_drawer_close.classList.add("active");
});
search_header_mobile.addEventListener("click", function (e) {
  e.preventDefault();

  search_drawer.classList.add("reveal");
  search_input.focus();
  document.body.classList.add("no-scroll");
  main_content.classList.add("shadow");
  search_drawer_close.classList.add("active");
});
search_drawer_close.addEventListener("click", function (e) {
  // Refactor This
  e.preventDefault();
  document.body.classList.remove("no-scroll");
  this.classList.remove("active");
  search_drawer.classList.remove("reveal");
  main_content.classList.remove("shadow");
});
main_content.addEventListener("click", function () {
  document.body.classList.remove("no-scroll");
  search_drawer.classList.remove("reveal");
  main_content.classList.remove("shadow");
  search_drawer_close.classList.remove("active");
});
main_content.classList.remove("loading");

/*---------------------------------------------------------
      Submenu reveal
    -----------------------------------------------------------*/
// TODO: Update variables titles, update to ES6, use data attr for selection

jQuery(document).ready(function ($) {
  $("body").removeClass("fade-out");
  var lists_with_dropdown = $(".list-item"),
    lists_with_dropdown_link = $(".list-item li a"); // Submenu device rules

  $(document).on("click", ".menu-title", function (e) {
    e.stopPropagation();
    $(this)
      .parent(".site-nav__level-2")
      .removeClass("submenu-active ")
      .parents(".list-item__has-dropdown")
      .removeClass("active");
  });
  lists_with_dropdown.click(function (e) {
    if ($(this).hasClass("list-item__has-dropdown")) {
      if ($(this).children(":first").attr("href") == "#") {
        e.preventDefault();
      }

      $(this).toggleClass("active").find("ul").toggleClass("submenu-active");
      if ($(this).hasClass("mobile__language-picker") && $(this).hasClass("active")) {
        document.querySelector('.site-menu').scrollTo(0,0);
      }
      $(".site-nav__level-2").removeClass("maison__active");
      $(".site-nav__level-2").removeClass("collection__active");
      $(".site-nav__level-2").removeClass("collection-season__active");
    }

    lists_with_dropdown.not(this).removeClass("active");
  });
  lists_with_dropdown_link.click(function (e) {
    e.stopPropagation();
  });
});

jQuery.fn.ucwords = function () {
  return this.each(function () {
    var val = $(this).text().toLowerCase(),
      newVal = "";
    val = val.split(" ");

    for (var c = 0; c < val.length; c++) {
      newVal +=
        val[c].substring(0, 1).toUpperCase() +
        val[c].substring(1, val[c].length) +
        (c + 1 == val.length ? "" : " ");
    }

    $(this).text(newVal);
  });
};

// Device Menu Reveal //

function closeAllModals() {
  var detailsModal = document.getElementById("details-modal"),
    shippingModal = document.getElementById("shipping-modal"),
    notifyModal = document.getElementById("notify-modal");

  if (typeof detailsModal != "undefined" && detailsModal != null) {
    detailsModal.classList.add("d-none");
  }

  if (typeof shippingModal != "undefined" && shippingModal != null) {
    shippingModal.classList.add("d-none");
  }

  if (typeof notifyModal != "undefined" && notifyModal != null) {
    notifyModal.classList.add("d-none");
  }

  if ($(".img-modal").length != 0) {
    $(".img-modal")
      .removeClass("active bg-gray-transparent")
      .addClass("bg-gray-100");
  }

  $("body").removeClass("overflow-hidden");
}

var deviceMenuButton = document.getElementById("menu-open"),
  deviceMenu = document.querySelector(".site-menu");
deviceMenuButton.addEventListener("click", function () {
  this.classList.toggle("active");
  var mobileSearchHeader = document.getElementById("search-header--mobile");
  var mobileCartHeader = document.querySelector(
    ".site-header__mobile-cart-mini"
  );
  var mobileWishlistHeader = document.querySelector(
    ".swym-wishlist.patou-wishlist"
  );

  mobileSearchHeader.classList.toggle("menu-active");
  if (mobileCartHeader) mobileCartHeader.classList.toggle("menu-active");
  if (mobileWishlistHeader)
    mobileWishlistHeader.classList.toggle("menu-active");

  document.querySelectorAll(".site-nav__level-2").forEach(function (submenu) {
    submenu.classList.remove("submenu-active");
    submenu.parentNode.classList.remove("active");

    if (submenu.querySelector(".ly-languages-switcher")) {
      submenu
        .querySelector(".ly-languages-switcher")
        .classList.remove("submenu-active");
    }
  });
  closeAllModals();
  setTimeout(function () {
    deviceMenu.classList.toggle("active");
  }, 7);
  setTimeout(function () {
    document.body.classList.toggle("no-scroll");
    document.body.classList.toggle("mobile-menu-open"); //document.querySelector('[data-html]').classList.toggle('no-scroll');
  }, 8);
});
var deviceMenuLanguages = document.getElementById(
  "footer__mobile-language-switcher"
);

function closeLanguageSubmenu(event) {
  deviceMenu
    .querySelector(".site-nav__level-2.header-device-languages")
    .parentNode.removeEventListener("click", closeLanguageSubmenu);
  deviceMenuButton.classList.remove("active");
  deviceMenu
    .querySelector(".site-nav__level-2.header-device-languages")
    .classList.remove("submenu-active");
  deviceMenu
    .querySelector(".site-nav__level-2.header-device-languages")
    .parentNode.classList.remove("active");
  deviceMenu
    .querySelector(
      ".site-nav__level-2.header-device-languages .ly-languages-switcher"
    )
    .classList.remove("submenu-active");
  setTimeout(function () {
    deviceMenu.classList.remove("active");
  }, 7);
  setTimeout(function () {
    document.body.classList.remove("no-scroll");
    document.body.classList.remove("mobile-menu-open"); //document.querySelector('[data-html]').classList.toggle('no-scroll');
  }, 8);
}

deviceMenuLanguages.addEventListener("click", function (e) {
  e.preventDefault();
  deviceMenuButton.classList.toggle("active");
  deviceMenu
    .querySelector(".site-nav__level-2.header-device-languages")
    .classList.toggle("submenu-active");
  deviceMenu
    .querySelector(".site-nav__level-2.header-device-languages")
    .parentNode.classList.toggle("active");
  if (
    deviceMenu.querySelector(
      ".site-nav__level-2.header-device-languages .ly-languages-switcher"
    )
  ) {
    deviceMenu
      .querySelector(
        ".site-nav__level-2.header-device-languages .ly-languages-switcher"
      )
      .classList.toggle("submenu-active");
  }
  deviceMenu
    .querySelector(".site-nav__level-2.header-device-languages")
    .parentNode.addEventListener("click", closeLanguageSubmenu);
  setTimeout(function () {
    deviceMenu.classList.toggle("active");
  }, 7);
  setTimeout(function () {
    document.body.classList.toggle("no-scroll");
    document.body.classList.toggle("mobile-menu-open"); //document.querySelector('[data-html]').classList.toggle('no-scroll');
  }, 8);
});

/*---------------------------------------------------------
    Ajax-esque - TODO
  -----------------------------------------------------------*/
// Add load in animations for page transitions
// Product Page

if (document.body.classList.contains("template-product")) {
  // Product Modal function
  // @TODO "Rip it out and start again~~~"
  var product_modal = function product_modal(openClass, closeClass, target) {
    if (openClass != null) {
      openClass.addEventListener("click", function (e) {
        target.classList.remove("d-none");
        $("body").addClass("modal-open");

        if ((target.id = "details-modal")) {
          document.body.style = "overflow-y:auto;";
        }
      });
    }

    if (closeClass != null) {
      closeClass.addEventListener("click", function (e) {
        target.classList.add("d-none");
        $("body").removeClass("modal-open");
      });
      closeClass.addEventListener("keypress", function (e) {
        if (e.key === "Enter") {
          target.classList.add("d-none");
          $("body").removeClass("modal-open");
        }
      });
    }
  }; // Carousel //

  // Product Details Modal
  var detailsModalOpen = document.getElementById("details-modal-open"),
    detailsModal = document.getElementById("details-modal"),
    detailsClose = document.querySelector("[data-close-details-modal]"); // Details Modal //

  if (
    detailsModalOpen != null &&
    detailsClose != null &&
    detailsModal != null
  ) {
    product_modal(detailsModalOpen, detailsClose, detailsModal);
  }

  if (window.innerWidth > 960) {
    $(detailsModalOpen).click(function () {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        "slow"
      );
      return false;
    });
  } // Product Shipping Modal

  if (!document.body.classList.contains("non-shoppable--region")) {
    var shippingModalOpen = document.getElementById("shipping-modal-open"),
      shippingModal = document.getElementById("shipping-modal"),
      shippingClose = document.querySelector("[data-close-shipping-modal]"); // Details Modal //

    product_modal(shippingModalOpen, shippingClose, shippingModal);

    if (window.innerWidth > 960) {
      $(shippingModalOpen).click(function () {
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          "slow"
        );
        return false;
      });
    }
  } // Sold Out Interest Modal //

  if (!document.body.classList.contains("non-shoppable--region")) {
    var notifyModalOpen = document.querySelector(".modal-link__notify-me"),
      notifyModalButtonOpen = document.querySelector(".notify-me-button"),
      notifyModal = document.getElementById("notify-modal"),
      notifyClose = document.getElementById("notify-close"),
      formId = document.getElementById("ProductVariantSelect");
    formId === null && (formId = notifyModalButtonOpen);

    if (formId != null) {
      if (
        formId.classList.contains("out-of-stock-items") &&
        notifyModalOpen != null &&
        notifyClose != null &&
        notifyModal != null
      ) {
        // This code only works if items out of stock
        product_modal(notifyModalOpen, notifyClose, notifyModal);
      }

      if (
        (formId.classList.contains("notify-me") ||
          formId.classList.contains("coming-soon")) &&
        notifyModalButtonOpen != null &&
        notifyClose != null &&
        notifyModal != null
      ) {
        // This code only works if items out of stock
        product_modal(notifyModalButtonOpen, notifyClose, notifyModal);
      }
    }
  }

  jQuery(function ($) {
    var product_image = $(".product-images__image img");
    var size_guide = $("#sizeGuide");
    var size_guide_content = $("#sizeGuideContent").contents();
    var product_image_modal = $(".img-modal"),
      product_image_modal_container = $(".img-modal__container .image"),
      img_modal_close = $("#img-modal-close");
    product_image_modal_container.click(function (e) {
      e.stopPropagation();
    });
    size_guide.click(function (e) {
      e.stopPropagation();
    });
    /*product_image.click(function (e) {
      e.stopPropagation();
      var img_link = $(this).data("img");
      product_image_modal.addClass("active");
      product_image_modal_container.empty().append('<img src=" ' + img_link + '">');
      $("body").addClass("overflow-hidden");
    });*/
    size_guide.click(function () {
      var img_src = $(this).data("img");
      product_image_modal.addClass("active");
      product_image_modal.toggleClass("bg-gray-100 bg-gray-transparent");
      product_image_modal_container.empty().append(size_guide_content);
      $("body").addClass("overflow-hidden");
    });
    img_modal_close.click(function () {
      product_image_modal_container.empty();
      product_image_modal
        .removeClass("active bg-gray-transparent")
        .addClass("bg-gray-100");
      $("body").removeClass("overflow-hidden");
    });
    $(document).click(function () {
      product_image_modal_container.empty();
      product_image_modal
        .removeClass("active bg-gray-transparent")
        .addClass("bg-gray-100");
      $("body").removeClass("overflow-hidden");
    });
  });
}

function filterBlog() {
  $(".blog-list__tags-list a").on("click", function () {
    $(this).toggleClass("active");
    $(".apply-filter").removeClass("opacity0");
    return false;
  });
  $(".blog-list__tags-list .current a").each(function () {
    $(this).addClass("active");
  });
  var taglist = "";
  $(".apply-filter").on("click", function (e) {
    e.preventDefault(); //get a list of the active filters and change the url

    $(".blog-list__tags-list a.active").each(function () {
      if (taglist == "") {
        taglist += "/tagged/" + $(this).parent().attr("data-tag");
      } else {
        taglist += "+" + $(this).parent().attr("data-tag");
      }
    });
    var buildLink = $(".clear-filter").attr("href"),
      newLink = buildLink + taglist;
    window.location.href = newLink;
  });
}

jQuery(function ($) {
  filterBlog();

  if ($(".contact__block-li").length != 0) {
    $(".contact__block-li a").on("click", function (e) {
      e.preventDefault();

      if ($(this).find(".contact__block-span").is(":hidden")) {
        $(".contact__block-span").removeClass("show");
        $(this).find(".contact__block-span").addClass("show");
      } else {
        var thishref = $(this).attr("href");

        if (thishref.indexOf("tel") != -1) {
          window.location = thishref;
        } else {
          var win = window.open(thishref, "_blank");
          win.focus();
        }
      }
    });
    $("body").on("click", function (event) {
      if (!$(event.target).closest(".contact__block-li a").length) {
        $(".contact__block-span").removeClass("show");
      }
    });
  }

  var relatedPostsGrid = $(".blog__related-stories__posts").imagesLoaded(
    function () {
      relatedPostsGrid.masonry({
        itemSelector: ".col",
      });
    }
  );
  $(".modal").on("hide.bs.modal", function (e) {
    var $if = $(e.delegateTarget).find("iframe");
    var src = $if.attr("src");
    $if.removeAttr("src");
    document.body.classList.remove("no-scroll-modal");
    $("html").removeClass("no-scroll-modal");
  });
  $(".modal").on("show.bs.modal", function (e) {
    var $if = $(e.delegateTarget).find("iframe");
    var src = $if.attr("data-src");
    $if.attr("src", src);
    document.body.classList.add("no-scroll-modal");
    $("html").addClass("no-scroll-modal");
  });

  if ($("#accordion").length != 0) {
    var anchor = window.location.hash;
    $(".collapse").collapse("hide");
    $(anchor).collapse("show");
    $("h2.accordion-item__title").on("click", function () {
      var thishash = $(this).find("button").data("target");
      window.location.hash = thishash;
    });
  } // Select all links with hashes NOT WORKING TM

  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      var thishref = $(this).attr("href"); // On-page links

      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        var thisHref = this.hash;
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]"); // Does a scroll target exist?

        if (target.length) {
          var to_remove = location.href.split("#").pop();
          location.href = location.href.replace(to_remove, thisHref); // Only prevent default if animation is actually gonna happen

          $("html, body").animate(
            {
              scrollTop: target.offset().top,
            },
            800,
            "swing",
            function () {
              // Callback after animation
              $(".collapse").not(target).removeClass("show"); // Must change focus!

              var $target = $(target); // $target.focus();

              $target.collapse("show");

              if ($target.is(":focus")) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                // $target.focus(); // Set focus again
              }
            }
          );
        }
      }
    });

  $(".header-device-languages").each(function () {
    $(this)
      .find(".li-current_lang")
      .insertAfter($(this).find(".back-link").parent());
  });
}); // Footer //

function accordion(element) {
  var columns = Array.from(document.querySelectorAll(element)); // Select the target element

  if (columns) {
    columns.forEach(function (column, index) {
      column.onclick = function (event) {
        var $target = $(event.target);
        if (!$target.is("a") && !$target.parents("a").length) {
          columns.forEach(function (c, i) {
            c.classList[index === i ? "toggle" : "remove"]("active"); // If its the target toggle the class if not remove it from the other similarly title elements

            c.nextElementSibling.classList[index === i ? "toggle" : "remove"](
              "active"
            ); // Do the same with accordion content
          });
        }
      };
    });
  }
}

accordion(".site-footer__column h2");

if ($(".details__text h3").length != 0) {
  accordion(".details__text h3");
}

if (document.getElementById("overlay")) {
  (function () {
    var _overlay = document.getElementById("overlay");

    var _clientY = null; // remember Y position on touch start

    _overlay.addEventListener(
      "touchstart",
      function (event) {
        if (event.targetTouches.length === 1) {
          // detect single touch
          _clientY = event.targetTouches[0].clientY;
        }
      },
      false
    );

    _overlay.addEventListener(
      "touchmove",
      function (event) {
        if (event.targetTouches.length === 1) {
          // detect single touch
          disableRubberBand(event);
        }
      },
      false
    );

    function disableRubberBand(event) {
      var clientY = event.targetTouches[0].clientY - _clientY;

      if (_overlay.scrollTop === 0 && clientY > 0) {
        // element is at the top of its scroll
        event.preventDefault();
      }

      if (isOverlayTotallyScrolled() && clientY < 0) {
        //element is at the top of its scroll
        event.preventDefault();
      }
    }

    function isOverlayTotallyScrolled() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
      return (
        _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight
      );
    }
  })();
}

function showhidepassword(id) {
  var x = document.getElementById(id);

  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
}

jQuery(function ($) {
  $(document) // Show/hide the password
    .on("click", ".toggle-password", function (e) {
      $(this).toggleClass("show-password");
      var id = $(this).attr("toggle");
      var input = $(this).parent().parent().find(id);

      if (input.attr("type") === "password") {
        input.attr("type", "text");
      } else {
        input.attr("type", "password");
      }
    }) // Unmark search input field when cleared
    .on("click", ".search__clear", function () {
      $(".search__filled").removeClass("search__filled");
    });
});

// Custom Select component - used in Welcome Mat
function CustomSelect(options) {
  var self = this;
  this.$elem = options.elemSelector
    ? document.querySelector(options.elemSelector)
    : options.$elem;
  this.inputTarget = this.$elem.getAttribute("for");
  this.$value = this.$elem.parentNode.querySelector(
    ".custom-select-value, [data-custom-select-value]"
  );
  this.$input = this.inputTarget
    ? document.querySelector("#" + this.inputTarget)
    : this.$elem.querySelector("select") || this.$elem.closest("select");

  function getSelectedOptionLabel() {
    return options.useOptionAttributeAsValueLabel
      ? self.$elem.nextElementSibling.options[
          self.$input.selectedIndex
        ].getAttribute(options.useOptionAttributeAsValueLabel)
      : self.$elem.nextElementSibling.value;
  }

  this.$input.onchange = function () {
    self.$value.innerText = getSelectedOptionLabel();
  };

  // Initialise with default input value
  this.$value.innerText = getSelectedOptionLabel();
}

var closeAllLy = document.getElementById("back-close-btn-ly");
if (closeAllLy) {
  closeAllLy.addEventListener("click", function () {
    var deviceMenuButton = document.getElementById("menu-open");
    deviceMenuButton.classList.remove("active");
    var mobileSearchHeader = document.getElementById("search-header--mobile"); //var mobileCartHeader = document.querySelector(".site-header__mobile-cart-mini");

    mobileSearchHeader.classList.toggle("menu-active"); //mobileCartHeader.classList.toggle("menu-active");

    document
      .querySelector(".site-nav__level-2")
      .classList.remove("submenu-active");
    document
      .querySelector(".site-nav__level-2.header-device-languages")
      .classList.remove("submenu-active");
    closeAllModals();
    setTimeout(function () {
      deviceMenu.classList.toggle("active");
    }, 7);
    setTimeout(function () {
      document.body.classList.toggle("no-scroll");
      document.body.classList.toggle("mobile-menu-open");
    }, 8);
  });
}
